import React from "react";
import { string, bool, func, number, oneOfType } from "prop-types";
import cx from "classnames";
import styles from "./Checkbox.module.scss";
import Icon from "../../assets/icons/Icon";
import { useCheckboxGroupContext } from "../CheckboxGroup/CheckboxGroup";
import useCheckbox from "./useCheckbox";

/**
 *
 * @returns A checkbox component, used in forms for multiple selections.
 *
 */

const Checkbox = (props) => {
  const groupValues = useCheckboxGroupContext();
  const mergedProps = { ...groupValues, ...props };

  const {
    children,
    className,
    isChecked: isCheckedProp,
    isDisabled = groupValues?.isDisabled,
    ...restProps
  } = mergedProps;

  // Check if checkbox group context exists, and consume its value
  // to determine if checkbox is checked or not.
  let isChecked = isCheckedProp;
  if (groupValues?.value && props.value) {
    isChecked = groupValues.value.includes(props.value);
  }

  const { state, getLabelProps, getInputProps } = useCheckbox({
    ...restProps,
    isChecked,
    isDisabled,
  });

  const classNames = cx(styles.checkbox, className);
  return (
    <label className={classNames} {...getLabelProps()}>
      <input className={styles.hiddenCheckbox} {...getInputProps()} />
      <span className={styles.control}>
        <div className={styles.checkContainer}>
          {state.isChecked ? (
            <Icon
              icon={state.isIndeterminate ? "GtLineAcross" : "GtCheckmark"}
              color="white"
            />
          ) : null}
        </div>
      </span>
      <span className={styles.label}>{children}</span>
    </label>
  );
};

export default Checkbox;

Checkbox.propTypes = {
  /** Value for state of checkbox. */
  isChecked: bool,
  /** Boolean to disable checkbox. */
  isDisabled: bool,
  /** Boolean to render checkbox as invalid. */
  isInvalid: bool,
  /** Boolean to render checkbox as reuqired. */
  isRequired: bool,
  /** Text to be displayed beside checkbox. */
  label: string,
  /** Name of item within a form. */
  name: string,
  /** Function to run when checkbox is clicked. */
  onChange: func,
  /** Value for when form is submitted. */
  value: oneOfType([string, number]),
};

Checkbox.defaultProps = {
  isChecked: false,
  label: "Checkbox",
};
